<template>
  <div
    v-if="authUser && sessionExpiresAt"
    v-b-tooltip.hover="expiryTooltip"
    class="session-countdown"
    :class="countdownClass"
    :aria-label="`Session time remaining: ${remainingLabel}`"
  >
    <i class="fa fa-clock-o" aria-hidden="true"></i>
    <span class="session-label">Session</span>
    <span class="session-time">{{ remainingLabel }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SessionCountdown',
  data () {
    return {
      now: Date.now(),
      timer: null
    }
  },
  computed: {
    ...mapGetters(['authUser', 'sessionExpiresAt']),
    remainingSeconds () {
      return Math.max(0, Math.ceil((this.sessionExpiresAt - this.now) / 1000))
    },
    remainingLabel () {
      const hours = Math.floor(this.remainingSeconds / 3600)
      const minutes = Math.floor((this.remainingSeconds % 3600) / 60)
      const seconds = this.remainingSeconds % 60

      return [hours, minutes, seconds]
        .map(value => String(value).padStart(2, '0'))
        .join(':')
    },
    countdownClass () {
      if (this.remainingSeconds <= 300) {
        return 'session-countdown-danger'
      }
      if (this.remainingSeconds <= 900) {
        return 'session-countdown-warning'
      }
      return ''
    },
    expiryTooltip () {
      if (this.remainingSeconds === 0) {
        return 'Session has expired'
      }
      return `Session expires at ${new Date(this.sessionExpiresAt).toLocaleString()}`
    }
  },
  mounted () {
    this.timer = window.setInterval(() => {
      this.now = Date.now()
    }, 1000)
  },
  beforeDestroy () {
    window.clearInterval(this.timer)
  }
}
</script>

<style scoped>
.session-countdown {
  align-items: center;
  border-left: 1px solid rgba(255, 255, 255, 0.08);
  color: #8c97a2;
  cursor: default;
  display: flex;
  flex: 0 0 auto;
  font-size: 11px;
  gap: 5px;
  margin-left: auto;
  opacity: 0.75;
  padding-left: 12px;
  white-space: nowrap;
}

.session-label {
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.session-time {
  color: #aab4bd;
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-variant-numeric: tabular-nums;
  min-width: 66px;
}

.session-countdown-warning,
.session-countdown-warning .session-time {
  color: #d7a928;
}

.session-countdown-danger,
.session-countdown-danger .session-time {
  color: #e26b69;
}

@media (max-width: 575.98px) {
  .session-label {
    display: none;
  }
}
</style>
